// src/lib/queryKeys.ts
export const qk = {
  me: () => ["me"] as const,
  scheduling: {
    all: () => ["scheduling"] as const,
    byProject: (projectId: number) =>
      ["scheduling", "project", projectId] as const,
    detail: (scheduleId: number) =>
      ["scheduling", "detail", scheduleId] as const,
  },
  coamAreas: () => ["coam-areas"] as const,
  geospatial: {
    quickFilter: (regionId: number | null) =>
      ["geospatial", "quick-filter", regionId] as const,
    workstack: (regionId: number | null) =>
      ["geospatial", "workstack", regionId] as const,
    projects: (params: {
      stage_gate_id?: number;
      phase_type_id?: number;
      region_id: number | null;
      phase_name?: string;
      page?: number;
      limit?: number;
    }) => ["geospatial", "projects", params] as const,
  },
};
